import React from "react";

export const NotFound404 = () => {
  return (
    <div className="d-flex flex-row align-items-center" style={{color:"white"}}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 text-center">
            <span className="display-1 d-block">404</span>
            <div className="mb-4 lead">The page you are looking for was not found.</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFound404;
